export const isTimeStamp = value => {
    if (/^\d+$/.test(value)) {
        const numericValue = Number(value)
        const date = new Date(numericValue)
        return !isNaN(date.getTime())
    }
    return false
}
